import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ClientService } from '../../../services/client.service';
import { ClientFamilyModel } from '../../../models/client-family.model';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'ngx-work-family',
  templateUrl: './family.component.html',
})
export class FamilyComponent implements OnInit {

  private _client_no: number;

  @Input() set client_no(value: number) {
    this._client_no = value;
  }

  get client_no(): number {
    return this._client_no;
  }

  constructor(
    public clientService: ClientService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
  }

  add() {
    $('#modalNewFamilyClient').modal('toggle')
  }

  edit(item: ClientFamilyModel) {
    this.clientService.family = item;
    $('#modalNewFamilyClient').modal('toggle')
  }

  delete(item: ClientFamilyModel){
    Swal.fire({
      title: 'Delete this Family?',
      text: 'Confirm Deletion of '+ item.first_name + ' ' + item.last_name,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
          this.clientService.deleteClientFamily(item.family_client_no).then(() => {
                Swal.fire({
                    title: 'Saved Successfully',
                    didOpen: () => {
                      this.clientService.getClientFamily(this.clientService.current_client_no).then(() => {}); 
                    },
                }) 
          })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return false;
      }
    });

     
  }
}
